import HeaderBar from "components/HeaderBar";
import Loading from "components/Loading";
import Page from "components/Page";
import { useRef, useState } from "react";
import { certGET } from "lib/API";
import SearchResult from "components/SearchResult";
import InputTextWithButton from "components/InputTextWithButton";
import { pluralN } from "lib/useful";
import { useEffect } from "react";
import { store } from "react-recollect";

function Search() {
  const h = window.location.hash.substring(1);
  const [searchText, setSearchText] = useState(() => {
    try {
      return atob(h);
    } catch (e) {
      console.log("hash", h, "did not decode");
      return "";
    }
  });
  const [search, setSearch] = useState(null);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);

  const timerRef = useRef();

  function setAndDo(text) {
    setSearchText(text);
    if (!timerRef.current)
      timerRef.current = setTimeout(() => doSearch(text), 150);
  }

  function doSearch(textArg) {
    const text = textArg || searchText;
    if (text.trim().length === 0) return;
    setResults(null);
    setLoading(true);
    setSearch(text);
    window.history.pushState(null, null, `#${btoa(text)}`); //window.location.hash = btoa(text);
    certGET(`search?q=${btoa(text)}`)
      .then(
        (r) => {
          setLoading(false);
          if (!r.ok) {
            r.text().then((t) => (store.error = JSON.stringify({ r, t })));
            return [];
          }
          return r.json();
        },
        (e) => console.error("error second?", e),
      )
      .then(setResults);
    timerRef.current = null;
  }

  useEffect(() => {
    if (h) {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(doSearch, 150);
    }
    return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line
  }, [h]);

  return (
    <Page title="Search">
      <HeaderBar>
        <InputTextWithButton
          value={searchText}
          setValue={setSearchText}
          buttonContent="Search"
          label="Enter search"
          onEnter={doSearch}
        />
      </HeaderBar>
      {(loading || timerRef.current) && (
        <Loading text="Getting results" size="10vw" />
      )}
      <div className="p-2">
        {results !== null && (
          <p>
            {results.length === 0
              ? "No results"
              : pluralN(results.length, "result")}{" "}
            for "{search}"
          </p>
        )}
        {results !== null &&
          results.length < 100 &&
          results.map((r, ri) => (
            <SearchResult key={ri} r={r} q={search} setAndDo={setAndDo} />
          ))}
        {results !== null && results.length >= 50 && (
          <>
            <p className="text-red-400 font-semibold italic">
              Too many results &mdash; be more specific
            </p>
            <h2 className="mt-4">Here are the first 50 results:</h2>
            {results.slice(0, 50).map((r, ri) => (
              <SearchResult key={ri} r={r} q={search} setAndDo={setAndDo} />
            ))}
          </>
        )}
      </div>
    </Page>
  );
}

export default Search;
